<template>
    <div ref="modal" class="modal fade" role="dialog">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">
                        Iniciar novo chat
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label>Selecione um setor</label>
                        <select class="form-control" v-model="setor_selecionado">
                            <option v-for="setor in setores" :value="setor">{{setor.nome}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Informe o assunto</label>
                        <input type="text" maxlength="50" v-model="assunto" class="form-control">
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="w-100">
                        <div class="float-right">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                            <button type="button" class="btn btn-success" :disabled="inserting" @click="CriarChat">Iniciar chat</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "messenger-novochat",
        data(){
            return {
                setores : [],
                assunto : null,
                setor_selecionado : null,
                inserting : false
            };
        },
        created() {
            var $vm = this;
            axios.get('/cliente/messenger/listar_setores').then((response) => {
                $vm.setores = response.data;
            });
        },
        methods : {
            Reset(){
                this.assunto = null;
                this.setor_selecionado = null;
            },
            Open(){
                this.Reset();
                $(this.$refs.modal).modal('show');
            },
            CriarChat(){
                this.inserting = true;
                axios.post('/cliente/messenger/novoChatSetor', {
                    setor_id : this.setor_selecionado.id,
                    subject: this.assunto
                }).then((response) => {
                    if (response.data.sucesso){
                        this.$emit('createdchat', response.data.chat_id);
                    }
                    this.Close();
                }).catch(() => {}).then(() => {
                    this.inserting = false;
                });
            },
            Close(){
                this.Reset();
                $(this.$refs.modal).modal('hide');
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/loja/vue-components/messenger-novochat.vue